var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4307 4.86445C27.0142 4.86445 27.5 5.34895 27.5 5.96544V6.53543C27.5 7.13693 27.0142 7.63642 26.4307 7.63642H1.57078C0.98579 7.63642 0.5 7.13693 0.5 6.53543V5.96544C0.5 5.34895 0.98579 4.86445 1.57078 4.86445H5.94435C6.83278 4.86445 7.60595 4.23296 7.80581 3.34197L8.03485 2.31898C8.3908 0.925491 9.56224 0 10.9029 0H17.0971C18.4232 0 19.6077 0.925491 19.9506 2.24548L20.1956 3.34047C20.394 4.23296 21.1672 4.86445 22.0571 4.86445H26.4307ZM24.2087 25.701C24.6653 21.4456 25.4648 11.3357 25.4648 11.2337C25.494 10.9247 25.3933 10.6322 25.1934 10.3967C24.979 10.1762 24.7077 10.0457 24.4086 10.0457H3.60278C3.30226 10.0457 3.01633 10.1762 2.81793 10.3967C2.61661 10.6322 2.51741 10.9247 2.532 11.2337C2.53468 11.2524 2.56337 11.6086 2.61133 12.2039C2.82438 14.8488 3.41775 22.2153 3.80118 25.701C4.07253 28.269 5.75747 29.883 8.19809 29.9415C10.0814 29.985 12.0217 30 14.0057 30C15.8744 30 17.7724 29.985 19.7141 29.9415C22.2393 29.898 23.9228 28.3125 24.2087 25.701Z",
    fill: "#EE3636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDelete);
export default __webpack_public_path__ + "static/media/red-Delete.114ba9a932ed504f119d23ed49a39a1d.svg";
export { ForwardRef as ReactComponent };